import { Content, isFilled } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import classNames from 'classnames';
import styles from 'components/PRISMIC/scss/pages.module.scss';
import PrismicConditionalLink from '../../PrismicConditionalLink';
import PrismicInlineText from '../../PrismicInlineText';

import type { JSX } from 'react';

/**
 * Props for `BlockQuote`.
 */
export type BlockQuoteProps = SliceComponentProps<Content.BlockQuoteSlice>;

const renderSpan = ({ children }: { children: React.ReactNode }) => (
  <span>{children}</span>
);

/**
 * Component for "BlockQuote" Slices.
 */
const BlockQuote = ({ slice }: BlockQuoteProps): JSX.Element => {
  return (
    <div className={styles['pages-module']}>
      <div className={styles.copy}>
        <blockquote
          data-slice-type={slice.slice_type}
          data-slice-variation={slice.variation}
          className={styles.pagesQuote}
        >
          <div className={classNames(styles.bq2, styles.m5)}>
            <PrismicInlineText
              field={slice.primary.text}
              components={{ paragraph: renderSpan }}
            />
          </div>
          {isFilled.richText(slice.primary.attribution) && (
            <cite className={[styles.pagesQuote__source, styles.h11].join(' ')}>
              <PrismicConditionalLink field={slice.primary.link}>
                <PrismicInlineText field={slice.primary.attribution} />
              </PrismicConditionalLink>
            </cite>
          )}
        </blockquote>
      </div>
    </div>
  );
};

export default BlockQuote;
